/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-filename-extension */
import React, {
  useState, useEffect, useMemo, useRef,
} from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import Select from 'react-select';
import { createPortal } from 'react-dom';
import moment from 'moment-timezone';
import { animated, useSpring } from 'react-spring';
import PropTypes from 'prop-types';

import { BoxShadow } from '../../../../../shared/GlobalStyles';
import iconSet from '../../../../../shared/images/teambuildr-selection.json';
import {
  setShareDashboardModal,
  fetchShareDashLink as fetchShareSCDashLink,
  clearShareDashLink as clearShareSCDashLink,
} from '../../../../sport-coach-dashboard/ducks/sportCoachDashboardActions';
import Button from '../../../../../shared/_TBComponents/Button';
import ShareDatePicker from './ShareDatePicker';
import Text from '../../../../../shared/components/Text/Text';
import { dashboardTracker } from '../../../../../shared/utils/amplitudeHelper';
import SharedTemplateModalContainer from './SharedTemplateModalContainer';
import {
  clearShareLMDashLink,
  fetchShareLMDashLink,
  setShareLMDashModal,
} from '../../../../load-monitoring-dashboard/ducks/loadMonitoringDashboardActions';
import {
  clearShareFPDashLink,
  fetchShareFPDashLink,
  setShareFPDashModal,
} from '../../../../force-plate-dashboard/ducks/forcePlateDashboardActions';
import {
  clearShareVTDashLink,
  fetchShareVTDashLink,
  setShareVTDashModal,
} from '../../../../volume-tracker-dashboard/ducks/volumeTrackerDashboardActions';
import SharedInput from '../../../../../shared/_TBComponents/Input';
import { clearShareVBTDashLink, fetchShareVBTDashLink, setShareVBTDashModal } from '../../../../vbt-dashboard/ducks/vbtDashboardActions';
import SharedDatePicker from '../../../../../shared/_TBComponents/DatePicker';

const BlockText = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 500;
`;

const BlockSubtext = styled('div')`
  color: #9E9E9E;
  font-family: 'Nunito Sans';
  font-size: 14px;
  font-weight: 400;
  white-space: break-spaces;
`;

const BucketWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  margin-right: 24px;
  width: 50%;
`;

const ButtonContainer = styled('div')`
  background: white;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
`;

const ContentContainer = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  max-height: ${(props) => props.customHeight};
  padding-left: 40px;
  padding-right: 40px;
  transition: max-height 0.5s linear;
  width: 100%;
`;

const DashDateContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  margin-top: 10px;
  width: 100%;
  .day-range-select {
    width: 90%;
  }
`;

const DashDateWrapper = styled('div')`
  display: flex;
`;

const DashDescription = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
`;

const DashLink = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 16px;
`;

const DashLinkBox = styled('div')`
  align-items: center;
  background: lightgray;
  border: 1px solid #eeeeee;
  border-radius: 4px;
  cursor: ${(props) => (props.hasLink ? 'pointer' : 'default')};
  display: flex;
  height: auto;
  overflow: hidden;
  padding: 10px;
  padding-left: 10px;
  user-select: none;
  white-space: wrap;
`;

const DashLinkContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  margin-top: 10px;
  width: 100%;
`;

const DatePickerDiv = styled('div')`
  align-items: center;
  border: 1px solid #eeeeee;
  border-radius: 8px;
  cursor: ${(props) => (props.disabled ? 'default' : 'pointer')};
  display: flex;
  height: 40px;
  justify-content: space-between;
  overflow: hidden;
  padding-left: 12px;
  width: 90%;
`;

const DatePickerDiv2 = styled('div')`
  align-items: center;
  border: 1px solid #eeeeee;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  height: 40px;
  justify-content: space-between;
  overflow: hidden;
  padding-left: 12px;
  width: 100%;
`;

const DatePickerText = styled('div')`
  color: ${(props) => (props.disabled ? '#9e9e9e' : '#444444')};
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
`;

const DayOption = styled('button')`
  border: none;
  color: ${(props) => (!props.isActive ? '#9E9E9E' : null)};
  cursor: pointer;
  font-family: 'Nunito Sans';
  font-size: 16px;
`;

const DaySelector = styled('div')`
  display: flex;
  margin-left: 10px;
`;

const DaySpacer = styled('span')`
  color: #9e9e9e;
  font-family: 'Nunito Sans';
  font-size: 25px;
  font-weight: 100;
  margin: 0px 3px;
`;

const Divider = styled('span')`
  align-content: center;
  color: #9E9E9E;
  line-height: 36px;
  margin: 0px 5px;
`;

const DownloadLinkDescText = styled('div')`
  color: #616161;
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  margin-bottom: 15px;
  margin-top: 15px;
`;

const ErrorBox = styled('div')`
  display: flex;
  flex-direction: column;
`;

const FlexWrapper = styled('div')`
  display: flex;
  flex-direction: row;
  margin: 10px 0;
`;

const HeaderIconContainer = styled('div')`
  align-items: center;
  border: 1px solid black;
  border-radius: 50%;
  display: flex;
  height: 52px;
  justify-content: center;
  width: 52px;
`;

const MappedError = styled('div')`
  color: #c0392b;
  font-family: 'Nunito Sans';
  font-size: ${(props) => (props.linkError ? '16px' : '14px')};
  margin-top: ${(props) => (props.linkError ? '10px' : '0px')};
`;

const Max = styled('input')`
  border-radius: 4px;
  font-size: 16px;
  padding: 8px 16px;  
  width: 45%;
`;

const Min = styled('input')`
  border-radius: 4px;
  font-size: 16px;
  padding: 8px 16px;
  width: 45%;
`;

const ModalContainer = styled('div')`
  border-radius: 12px;
  left: 50%;
  max-height: calc(100vh - 20px);
  max-width: 600px;
  min-height: 270px;
  min-width: 430px;
  overflow: auto;
  position: absolute;
  right: 50%;
  top: 50%;
  transition: all 0.3s linear, opacity 0.3s ease-out;
  opacity: ${(props) => (props.isActive ? '1' : '0')};
  visibility: ${(props) => (props.isActive ? 'visible' : 'hidden')};
  transform: ${(props) => (props.isActive ? 'translate(-50%,-50%)' : 'translate(-50%, 300%)')};
  user-select: none;
  width: fit-content;
  z-index: 1003;

  @media only screen and (max-width: 768px) {
    width: 90vw;
  }
`;

const ModalHeader = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  margin-top: 40px;
  width: 100%;
`;

const ModalHeaderText = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 24px;
  font-weight: 400;
  margin-top: 10px;
`;

const NoteText = styled('div')`
  font-family: 'Nunito Sans';
  font-size: 12px;
  font-weight: 700;
`;

const PortalContainer = styled('div')`
  background: white;
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
  box-shadow: ${BoxShadow};
  overflow: auto;
  width: 100%;
`;

const RangeWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;

  .volume-tracker-range {
    align-items: center;
    display: flex;
    gap: 10px;
  }

  .volume-tracker-select {
    flex: 1;
  }
`;

const RelativePortalContainer = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const RemoveDiv = styled('div')`
  background: white;
  color: #444444;
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  width: 100%;
  z-index: 1001;

  .remove-div-icon {
    cursor: pointer;
  }
`;

const Slide = styled('div')`
  display: inline-flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
`;

const Slide2Block2 = styled('div')`
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  margin-top: 10px;
`;

const SlideCenterDiv = styled('div')``;

const SlideIndicator = styled('div')`
  background: ${(props) => (props.isActive ? 'grey' : 'none')};
  border: 1px solid grey;
  border-radius: 50%;
  height: 7px;
  margin-left: 5px;
  margin-right: 5px;
  transition: background-color 0.5s ease;
  width: 7px;
`;

const SlideIndicators = styled('div')`
  align-items: center;
  background: white;
  display: flex;
  height: 40px;
  justify-content: center;
  width: 100%;
`;

const Slides = styled('div')`
  height: 100%;
  transition: transform 0.5s ease;
  transform: ${(props) => `translateX(-${props.activeSlide * 100}%)`};
  white-space: nowrap;
`;

const SlidesContainer = styled('div')`
  max-height: ${(props) => props.customHeight};
  overflow: hidden;
  transition: max-height 1s linear;
  width: 100%;
`;

const TextAndCopy = styled('div')`
  align-items: center;
  display: flex;
`;

const ThresholdContainer = styled('div')`
  align-items: center;
  display: flex;
  margin-bottom: 5px;
`;

const ThresholdsContainer = styled('div')`
  display: flex;
  flex-direction: ${(props) => (props.direction)};
  font-family: 'Nunito Sans';
  font-size: 16px;
  font-weight: bold;
  margin: 10px 0px 10px 25px;
`;

const VolumeTrackerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
`;

const dayRangeOptions = [
  { label: '7 Days', value: 7 },
  { label: '28 Days', value: 28 },
];

const ShareDashboardModal = ({ dashboard, legacyName }) => {
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  let activeTemplate = null;
  let clearShareDashLink = () => {};
  let dateType = null;
  let dayRange = 7;
  let endDateCal = null;
  let exercises = [];
  let fetchShareDashLink = () => {};
  let graphThresholds = [];
  let group = null;
  let groups = [];
  let isModalShowing = false;
  let keyPerformanceMetrics = [];
  let loadMonitoringFormValues = {};
  let maxType = null;
  let metricFiltersGroup = [];
  let metricFiltersPerformance = [];
  let setShareModalShowing = () => {};
  let shareDashLink = null;
  let shareDashLinkError = null;
  let shareDashLinkLoading = false;
  let shareTemplate = {};
  let startDateCal = null;
  let tableThreshold = null;
  let vbtDateRange = 13;

  const dispatch = useDispatch();

  if (dashboard === 'Force Plate') {
    activeTemplate = useSelector((state) => state.forcePlateDashboard.data.activeTemplate);
    clearShareDashLink = clearShareFPDashLink;
    endDateCal = useSelector((state) => state.forcePlateDashboard.data.endDateCal);
    fetchShareDashLink = fetchShareFPDashLink;
    group = useSelector((state) => state.forcePlateDashboard.data.group);
    groups = useSelector((state) => state.forcePlateDashboard.data.groups);
    isModalShowing = useSelector((state) => state.forcePlateDashboard.ui.shareModalShowing);
    keyPerformanceMetrics = useSelector(
      (state) => state.forcePlateDashboard.data.keyPerformanceMetrics,
    );
    metricFiltersGroup = useSelector((state) => state.forcePlateDashboard.data.metricFiltersGroup);
    metricFiltersPerformance = useSelector(
      (state) => state.forcePlateDashboard.data.metricFiltersPerformance,
    );
    setShareModalShowing = setShareFPDashModal;
    shareDashLink = useSelector((state) => state.forcePlateDashboard.data.shareDashLink);
    shareDashLinkError = useSelector(
      (state) => state.forcePlateDashboard.data.shareDashLinkError,
    );
    shareDashLinkLoading = useSelector(
      (state) => state.forcePlateDashboard.ui.isShareDashLinkLoading,
    );
    shareTemplate = useSelector((state) => state.forcePlateDashboard.data.shareTemplate);
    startDateCal = useSelector((state) => state.forcePlateDashboard.data.startDateCal);
  }

  if (dashboard === 'KPI Tracker') {
    activeTemplate = useSelector((state) => state.sportCoachDashboard.data.template);
    clearShareDashLink = clearShareSCDashLink;
    dateType = useSelector((state) => state.sportCoachDashboard.data.dateType);
    endDateCal = useSelector((state) => state.sportCoachDashboard.data.endDateCal);
    exercises = useSelector((state) => state.sportCoachDashboard.data.exercises);
    fetchShareDashLink = fetchShareSCDashLink;
    group = useSelector((state) => state.sportCoachDashboard.data.group);
    groups = useSelector((state) => state.sportCoachDashboard.data.groups);
    isModalShowing = useSelector(
      (state) => state.sportCoachDashboard.ui.isShareDashModalShowing,
    );
    maxType = useSelector((state) => state.sportCoachDashboard.data.maxType);
    setShareModalShowing = setShareDashboardModal;
    shareDashLink = useSelector((state) => state.sportCoachDashboard.data.shareDashLink);
    shareDashLinkError = useSelector((state) => state.sportCoachDashboard.data.shareDashLinkError);
    shareDashLinkLoading = useSelector(
      (state) => state.sportCoachDashboard.ui.isShareDashLinkLoading,
    );
    shareTemplate = useSelector((state) => state.sportCoachDashboard.data.shareTemplate);
    startDateCal = useSelector((state) => state.sportCoachDashboard.data.startDateCal);
  }

  if (dashboard === 'Load Monitoring') {
    activeTemplate = useSelector((state) => state.loadMonitoringDashboard.data.activeTemplate);
    clearShareDashLink = clearShareLMDashLink;
    dayRange = useSelector((state) => state.loadMonitoringDashboard.data.dayRange);
    endDateCal = useSelector(
      (state) => state.loadMonitoringDashboard.data.currentDateInDashDatePicker?.date,
    );
    fetchShareDashLink = fetchShareLMDashLink;
    group = useSelector((state) => state.loadMonitoringDashboard.data.currentGroupInGroupPicker);
    groups = useSelector((state) => state.loadMonitoringDashboard.data.reportableGroups);
    isModalShowing = useSelector((state) => state.loadMonitoringDashboard.ui.shareModalShowing);
    loadMonitoringFormValues = useSelector(
      (state) => state.loadMonitoringDashboard.data.loadMonitoringFormValues,
    );
    setShareModalShowing = setShareLMDashModal;
    shareDashLink = useSelector((state) => state.loadMonitoringDashboard.data.shareDashLink);
    shareDashLinkError = useSelector(
      (state) => state.loadMonitoringDashboard.data.shareDashLinkError,
    );
    shareDashLinkLoading = useSelector(
      (state) => state.loadMonitoringDashboard.ui.isShareDashLinkLoading,
    );
    shareTemplate = useSelector((state) => state.loadMonitoringDashboard.data.shareTemplate);
  }

  if (dashboard === 'VBT') {
    activeTemplate = useSelector((state) => state.vbtDashboard.data.activeTemplate);
    clearShareDashLink = clearShareVBTDashLink;
    endDateCal = useSelector(
      (state) => state.vbtDashboard.data.endDateData,
    );
    exercises = useSelector((state) => state.vbtDashboard.data.exercises);
    fetchShareDashLink = fetchShareVBTDashLink;
    graphThresholds = useSelector((state) => state.vbtDashboard.data.graphThresholds);
    group = useSelector((state) => state.vbtDashboard.data.group);
    groups = useSelector(
      (state) => state.vbtDashboard.data.groups,
    );
    isModalShowing = useSelector((state) => state.vbtDashboard.ui.shareModalShowing);
    setShareModalShowing = setShareVBTDashModal;
    shareDashLink = useSelector((state) => state.vbtDashboard.data.shareDashLink);
    shareDashLinkError = useSelector((state) => state.vbtDashboard.data.shareDashLinkError);
    shareDashLinkLoading = useSelector(
      (state) => state.vbtDashboard.ui.isShareDashLinkLoading,
    );
    shareTemplate = useSelector((state) => state.vbtDashboard.data.shareTemplate);
    tableThreshold = useSelector((state) => state.vbtDashboard.data.tableThreshold);
    vbtDateRange = useSelector((state) => state.vbtDashboard.data.dateRange);
  }

  if (dashboard === 'Volume Tracker') {
    activeTemplate = useSelector((state) => state.volumeTrackerDashboard.data.activeTemplate);
    clearShareDashLink = clearShareVTDashLink;
    dateType = useSelector((state) => state.volumeTrackerDashboard.data.dateType);
    endDateCal = useSelector((state) => state.volumeTrackerDashboard.data.selectedEndDate);
    exercises = useSelector((state) => state.volumeTrackerDashboard.data.exercises);
    fetchShareDashLink = fetchShareVTDashLink;
    group = useSelector((state) => state.volumeTrackerDashboard.data.group);
    groups = useSelector(
      (state) => state.volumeTrackerDashboard.data.groups,
    );
    isModalShowing = useSelector((state) => state.volumeTrackerDashboard.ui.shareModalShowing);
    setShareModalShowing = setShareVTDashModal;
    shareDashLink = useSelector((state) => state.volumeTrackerDashboard.data.shareDashLink);
    shareDashLinkError = useSelector(
      (state) => state.volumeTrackerDashboard.data.shareDashLinkError,
    );
    shareDashLinkLoading = useSelector(
      (state) => state.volumeTrackerDashboard.ui.isShareDashLinkLoading,
    );
    shareTemplate = useSelector((state) => state.volumeTrackerDashboard.data.shareTemplate);
    startDateCal = useSelector((state) => state.volumeTrackerDashboard.data.selectedStartDate);
  }

  const [activeSlide, setActiveSlide] = useState(0);
  const [copySuccess, setCopySuccess] = useState(false);
  const [dashDescription, setDashDescription] = useState('');
  const [dashTitle, setDashTitle] = useState('');
  const [dscElement, setDscElement] = useState(null);
  const [dscElement2, setDscElement2] = useState(null);
  const [errors, setErrors] = useState({
    errorsExist: false,
    errors: [
      {
        error: 'name error',
        msg: 'You must add a title for the shared dashboard',
        isShowing: false,
      },
      {
        error: 'select group error',
        msg: 'You must select a group',
        isShowing: false,
      },
      {
        error: 'API error',
        msg:
          'Unable to create shareable link, please check the form and try again',
        isShowing: false,
      },
      {
        error: 'threshold error',
        msg: 'One or more thresholds are invalid, please check and try again',
        isShowing: false,
      },
      {
        error: 'duplicate threshold error',
        msg: 'You cannot have duplicate performance overview thresholds',
        isShowing: false,
      },
    ],
  });
  const [errorsMulti, setErrorsMulti] = useState(
    graphThresholds?.length
      ? graphThresholds.map(() => ({ min: false, max: false }))
      : [{ min: false, max: false }],
  );
  const [errorsThreshold, setErrorsThreshold] = useState({ min: false, max: false });
  const [gThresholds, setGThresholds] = useState(
    graphThresholds?.length
      ? graphThresholds
      : [{ min: '', max: '' }, { min: '', max: '' }, { min: '', max: '' }],
  );
  const [localGroup, setLocalGroup] = useState(null);
  const [localVBTDateRange, setLocalVBTDateRange] = useState(vbtDateRange);
  const [loadMonitoringDayRange, setLoadMonitoringDayRange] = useState(
    dayRangeOptions[0],
  );
  const [pickerOpen, setPickerOpen] = useState(false);
  const [pickerOpen2, setPickerOpen2] = useState(false);
  const [selectedEndDate, setSelectedEndDate] = useState(moment());
  const [selectedStartDate, setSelectedStartDate] = useState(moment());
  const [tThreshold, setTThreshold] = useState({ min: tableThreshold?.min ?? '', max: tableThreshold?.max ?? '' });
  const [volumeTrackerBucketSize, setVolumeTrackerBucketSize] = useState(10);
  const [volumeTrackerMaxRange, setVolumeTrackerMaxRange] = useState(100);
  const [volumeTrackerMinRange, setVolumeTrackerMinRange] = useState(0);

  const prevBucketSizeRef = useRef(volumeTrackerBucketSize);

  const uniqueFilters = (filterArray) => {
    if (!filterArray) return [];
    const uniqueArr = [];
    filterArray.forEach((filterObj) => {
      if (!uniqueArr.some((obj) => obj.name === filterObj.name)) uniqueArr.push(filterObj);
    });
    return uniqueArr;
  };

  const chartForcePlateMetrics = !!Object.keys(shareTemplate).length && dashboard === 'Force Plate'
    ? uniqueFilters(shareTemplate.chartForcePlateMetrics).map((metric) => metric.name.replace(/\s/g, ''))
    : metricFiltersPerformance;
  const kpiForcePlateMetrics = !!Object.keys(shareTemplate).length && dashboard === 'Force Plate'
    ? uniqueFilters(shareTemplate.kpiForcePlateMetrics).map((metric) => metric.name.replace(/\s/g, ''))
    : keyPerformanceMetrics.map((metric) => metric.replace(/\s/g, ''));
  const groupAnalysisForcePlateMetrics = (dashboard === 'Force Plate' && activeTemplate && metricFiltersGroup)
  || kpiForcePlateMetrics;

  const copyAnimation = useSpring({ opacity: copySuccess ? 1 : 0 });

  const disabledStartDate = (date) => {
    if (dashboard === 'Volume Tracker') return false;
    if (selectedEndDate && moment(date).isSame(selectedEndDate, 'day')) return false;
    return selectedEndDate && moment(date).isAfter(selectedEndDate, 'day');
  };
  const disabledEndDate = (date) => {
    if (selectedStartDate && moment(date).isSame(selectedStartDate, 'day')) return false;
    const isBeforeStart = selectedStartDate && moment(date).isBefore(selectedStartDate, 'day');

    const isVolumeTrackerLimit = dashboard === 'Volume Tracker'
      && selectedStartDate
      && moment(date).diff(selectedStartDate, 'days') >= 56;

    return isBeforeStart || isVolumeTrackerLimit;
  };

  const exerIds = exercises.length > 0
    ? exercises.map((item) => item.id)
    : shareTemplate?.exercises?.map((item) => item.id);

  /** When opening from template grid, template with group access marked private
   * should allow all user groups for template owner, empty array for non-owner (non-owners
   * theoretically shouldn't see these templates anyway)
   * Otherwise shareTemplate.groups will represent intersection of user's groups
   * and template's groups.
   * When viewing share modal from dashboard view, groups will already
   * be set as noted above */
  const groupOptions = () => {
    if (Object.keys(shareTemplate).length) {
      if (!shareTemplate.groups.length) {
        if (shareTemplate.createdBy === currentUser?.id) return groups;
        return [];
      }
      return shareTemplate.groups;
    }
    return groups;
  };

  const range = volumeTrackerBucketSize === 5 ? 50 : 100;

  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareDashLink);
    setCopySuccess(true);
    setTimeout(() => {
      setCopySuccess(false);
    }, 3000);
  };

  // We need this to send the correct buckets to backend
  // e.g. 90-100 would be min 90 and max 90 to backend as it reads max 90 as the 90-100 bucket
  const getBackendRangeMax = (rangeMax, bucketSize) => (
    rangeMax === 110 ? 100 : rangeMax - bucketSize);

  const rangeOptions = useMemo(() => {
    const steps = Math.floor(100 / volumeTrackerBucketSize) + 1;
    return Array.from({ length: steps }, (_, i) => {
      const value = i * volumeTrackerBucketSize;
      return { id: value, label: `${value}%` };
    });
  }, [volumeTrackerBucketSize]);

  const getRangeOptions = (fromValueId) => {
    if (fromValueId == null) return [];

    if (fromValueId === 100) return [{ id: 110, label: '100%+' }];

    const min = fromValueId + volumeTrackerBucketSize;
    const max = fromValueId + range;

    const rangeArray = Array.from(
      { length: (max - min) / volumeTrackerBucketSize + 1 },
      (_, i) => {
        const value = min + i * volumeTrackerBucketSize;
        return { id: value, label: `${value}%` };
      },
    ).filter(({ id }) => id <= 100);

    const allowHundredPlus = fromValueId >= 10
    && (110 - (fromValueId + volumeTrackerBucketSize)) <= range;

    if (allowHundredPlus) {
      rangeArray.push({ id: 110, label: '100%+' });
    }

    return rangeArray;
  };

  const handleClose = () => {
    batch(() => {
      dispatch(setShareModalShowing(false));
      dispatch(clearShareDashLink());
    });
    setActiveSlide(0);
    setDashTitle('');
    setDashDescription('');
    setLocalGroup(group || null);
  };

  const handleRangeMin = (selected) => {
    const newMin = selected.id;
    setVolumeTrackerMinRange(newMin);
    const validMaxOptions = getRangeOptions(newMin);
    const validMaxIds = validMaxOptions.map((opt) => opt.id);

    // Only change max if current one is invalid
    if (!validMaxIds.includes(volumeTrackerMaxRange)) {
      const fallback = validMaxOptions[0];
      setVolumeTrackerMaxRange(fallback?.id || null);
    }
  };

  const handleSelectEndDate = (date) => {
    setSelectedEndDate(date);
  };

  const handleSelectStartDate = (date) => {
    setSelectedStartDate(date);

    if (dashboard === 'Volume Tracker') {
      const maxAllowedEnd = moment(date).add(55, 'days');
      const today = moment();

      const newEndDate = maxAllowedEnd.isAfter(today) ? today : maxAllowedEnd;
      setSelectedEndDate(newEndDate);
    }
  };

  const handleTableThresholdChange = (field, value) => {
    const newErrors = { ...errors };
    newErrors.errors[3].isShowing = false;
    newErrors.errorsExist = false;
    setErrors(newErrors);

    // Limit to 2 decimal places
    const formattedValue = value.includes('.')
      ? value.replace(/\.(\d{0,2}).*/, '.$1')
      : value;

    setTThreshold((prevThreshold) => {
      const updated = { ...prevThreshold, [field]: formattedValue };
      const newMin = updated.min !== undefined ? updated.min : '';
      const newMax = updated.max !== undefined ? updated.max : '';
      const hasValue = newMin !== '' || newMax !== '';

      setErrorsThreshold(() => ({
        min: hasValue && (newMin === '' || Number(newMin) <= 0),
        max: hasValue && (newMax === '' || Number(newMax) <= 0 || (newMin !== '' && Number(newMax) <= Number(newMin))),
      }));

      return updated;
    });
  };

  const handleThresholdChange = (index, field, value) => {
    const newErrors = { ...errors };
    newErrors.errors[3].isShowing = false;
    newErrors.errorsExist = false;
    setErrors(newErrors);

    // Limit to 2 decimal places
    const formattedValue = value.includes('.')
      ? value.replace(/\.(\d{0,2}).*/, '.$1')
      : value;

    setGThresholds((prevThresholds) => {
      const updatedThresholds = [...prevThresholds];
      const prev = updatedThresholds[index] || { min: '', max: '' };
      const updated = { ...prev, [field]: formattedValue };
      updatedThresholds[index] = updated;

      setErrorsMulti((prevErrors) => {
        const updatedErrors = [...prevErrors];
        const newMin = updated.min;
        const newMax = updated.max;
        const hasValue = newMin !== '' || newMax !== '';

        updatedErrors[index] = {
          min: hasValue && (newMin === '' || Number(newMin) <= 0),
          max: hasValue && (newMax === '' || Number(newMax) <= 0 || (newMin !== '' && Number(newMax) <= Number(newMin))),
        };

        return updatedErrors;
      });

      return updatedThresholds;
    });
  };

  const isRangeValid = (min, max) => {
    const isHundredPlus = max === 110;
    if (isHundredPlus) return (110 - (min + volumeTrackerBucketSize)) <= range;
    return max - min <= range;
  };

  const isValidThreshold = (t) => {
    const min = Number(t.min);
    const max = Number(t.max);
    return (
      t.min !== '' && t.max !== ''
      && !Number.isNaN(min) && !Number.isNaN(max)
    );
  };

  const mapToNumeric = (t) => ({
    ...t,
    min: Number(t.min),
    max: Number(t.max),
  });

  const normalizeRange = (min, max) => {
    const roundedMax = max % volumeTrackerBucketSize !== 0
      ? Math.ceil(max / volumeTrackerBucketSize) * volumeTrackerBucketSize
      : max;
    const maxAllowedRange = range;
    const currentRange = roundedMax - min;
    const isValidRange = currentRange <= maxAllowedRange;

    if (isValidRange) {
      const cleanMin = min % volumeTrackerBucketSize !== 0
        ? Math.floor(min / volumeTrackerBucketSize) * volumeTrackerBucketSize
        : min;
      return [cleanMin, roundedMax];
    }

    const fallbackMin = Math.max(0, roundedMax - maxAllowedRange);
    const roundedMin = fallbackMin % volumeTrackerBucketSize !== 0
      ? Math.ceil(fallbackMin / volumeTrackerBucketSize) * volumeTrackerBucketSize
      : fallbackMin;

    return [roundedMin, roundedMax];
  };

  const preventEAndMinus = (e) => {
    if (e.key === 'e' || e.key === 'E' || e.key === '-') {
      e.preventDefault();
    }
  };

  const thresholdValidator = () => {
    // Check for individual threshold errors
    const hasTableThresholdErrors = errorsThreshold?.min || errorsThreshold?.max;
    const hasGraphThresholdErrors = gThresholds?.some((t, i) => {
      const err = errorsMulti[i] || {};
      return (err.min || err.max);
    });

    if (hasTableThresholdErrors || hasGraphThresholdErrors) {
      return 'thresholdError';
    }

    // Check for duplicate graph thresholds
    const validGraphThresholds = gThresholds?.filter(isValidThreshold) || [];

    // Normalize thresholds by converting to numbers and creating normalized strings
    const normalizedThresholds = validGraphThresholds.map((t) => {
      const min = Number(t.min);
      const max = Number(t.max);
      return {
        min,
        max,
        normalizedString: `${min}-${max}`,
      };
    });

    // Check for duplicates using normalized values
    const thresholdStrings = normalizedThresholds.map((t) => t.normalizedString);
    const uniqueThresholdStrings = [...new Set(thresholdStrings)];
    const hasDuplicateThresholds = thresholdStrings.length !== uniqueThresholdStrings.length;

    if (hasDuplicateThresholds) {
      return 'duplicatesError';
    }

    return null;
  };

  const vbtHandleSubmit = () => {
    if (dashTitle.length) {
      if (activeSlide === 0) {
        if (localGroup && Object.keys(localGroup).length) {
          setActiveSlide(1);
        } else {
          const newErrors = { ...errors };
          newErrors.errors[1].isShowing = true;
          newErrors.errorsExist = true;
          setErrors(newErrors);
        }
      } else if (activeSlide === 1) {
        const thresholdError = thresholdValidator();
        if (thresholdError) {
          const newErrors = { ...errors };

          if (thresholdError === 'duplicatesError') {
            newErrors.errors[4].isShowing = true;
            newErrors.errors[3].isShowing = false;
          } else if (thresholdError === 'thresholdError') {
            newErrors.errors[3].isShowing = true;
            newErrors.errors[4].isShowing = false;
          }
          newErrors.errorsExist = true;
          setErrors(newErrors);
        } else {
          const newErrors = { ...errors };
          newErrors.errors[3].isShowing = false;
          newErrors.errors[4].isShowing = false;
          newErrors.errorsExist = false;
          setErrors(newErrors);

          const submissionObj = {
            dashboardDescription: dashDescription,
            dashboardTitle: dashTitle,
            endDate: moment(selectedEndDate).format('YYYY-MM-DD'),
            exerciseIds: exerIds,
            groupId: localGroup.id,
            startDate: moment(selectedEndDate).subtract(localVBTDateRange, 'd').format('YYYY-MM-DD'),
            thresholds: {
              graphThresholds: gThresholds.filter(isValidThreshold).map(mapToNumeric),
              tableThreshold: isValidThreshold(tThreshold)
                ? mapToNumeric(tThreshold) : {},
            },
          };

          dispatch(fetchShareDashLink(currentUser?.accountCode, submissionObj));
          // Amplitude tracking
          dashboardTracker(
            'VBT Dashboard',
            'Share Dashboard',
            'Shareable dashboard link created',
          );
          setTimeout(() => {
            setActiveSlide(2);
          }, 500);
        }
      } else {
        handleClose();
      }
    } else {
      const newErrors = { ...errors };
      newErrors.errors[0].isShowing = true;
      newErrors.errorsExist = true;
      setErrors(newErrors);
    }
  };

  const handleSubmit = () => {
    if (dashTitle.length) {
      if (activeSlide === 0) {
        if (localGroup && Object.keys(localGroup).length) {
          let submissionObj = {
            dashboardTitle: dashTitle,
            dashboardDescription: dashDescription,
            groupId: localGroup.id,
            endDate: selectedEndDate.format('YYYY-MM-DD'),
          };
          if (dashboard === 'Load Monitoring') {
            let isQuestionnaire;
            let itemIds;
            let showTotals;
            let showAverages;
            // SHARING EXISTING TEMPLATE FROM TEMPLATE SELECTION PAGE
            if (Object.keys(shareTemplate).length) {
              const sharedItemIds = shareTemplate?.isQuestionnaire
                ? [shareTemplate?.questionnaire.id]
                : shareTemplate?.questions.map((question) => question.id);
              isQuestionnaire = shareTemplate.isQuestionnaire;
              itemIds = sharedItemIds;
              showTotals = shareTemplate.showTotals;
              showAverages = shareTemplate.showAverages;
              // SHARING EXISTING TEMPLATE THAT IS CURRENTLY BEING VIEWED
            } else if (activeTemplate) {
              const activeItemIds = activeTemplate?.isQuestionnaire
                ? [activeTemplate?.questionnaire.id]
                : activeTemplate?.questions.map((question) => question.id);
              isQuestionnaire = activeTemplate.isQuestionnaire;
              itemIds = activeItemIds;
              showTotals = activeTemplate.showTotals;
              showAverages = activeTemplate.showAverages;
              // SHARING UNSAVED DASHBOARD
            } else {
              isQuestionnaire = !!loadMonitoringFormValues.questionnaire?.id;
              itemIds = loadMonitoringFormValues.questionnaire?.id
                ? [loadMonitoringFormValues.questionnaire.id]
                : loadMonitoringFormValues.arrayOfQuestions.map(
                  (question) => question.id,
                );
              showTotals = loadMonitoringFormValues.showTotal;
              showAverages = loadMonitoringFormValues.showRangeAverages;
            }
            submissionObj = {
              ...submissionObj,
              daysToGoBack: loadMonitoringDayRange.value,
              isQuestionnaire,
              itemIds,
              showTotals,
              showAverages,
            };
          }
          if (dashboard === 'Force Plate') {
            submissionObj = {
              ...submissionObj,
              startDate: selectedStartDate.format('YYYY-MM-DD'),
              chartForcePlateMetrics,
              kpiForcePlateMetrics,
              groupAnalysisForcePlateMetrics,
            };
          }
          if (dashboard === 'KPI Tracker') {
            submissionObj = {
              ...submissionObj,
              startDate: selectedStartDate.format('YYYY-MM-DD'),
              exerciseIds: exerIds,
              dateType,
              maxType,
            };
          }
          if (dashboard === 'Volume Tracker') {
            submissionObj = {
              ...submissionObj,
              title: dashTitle,
              description: dashDescription,
              startDate: selectedStartDate.format('YYYY-MM-DD'),
              endDate: selectedEndDate.format('YYYY-MM-DD'),
              exerciseIds: exerIds,
              dateType,
              rangeMin: volumeTrackerMinRange,
              rangeMax: getBackendRangeMax(volumeTrackerMaxRange, volumeTrackerBucketSize),
              bucketSize: volumeTrackerBucketSize,
            };
          }
          dispatch(fetchShareDashLink(currentUser?.accountCode, submissionObj));
          // Amplitude tracking
          dashboardTracker(
            `${legacyName} Dashboard`,
            'Share Dashboard',
            'Shareable dashboard link created',
          );
          setTimeout(() => {
            setActiveSlide(1);
          }, 500);
        } else {
          const newErrors = { ...errors };
          newErrors.errors[1].isShowing = true;
          newErrors.errorsExist = true;
          setErrors(newErrors);
        }
      } else {
        handleClose();
      }
    } else {
      const newErrors = { ...errors };
      newErrors.errors[0].isShowing = true;
      newErrors.errorsExist = true;
      setErrors(newErrors);
    }
  };

  // Properly set group, title, description, start date, and end date for select drop-down
  useEffect(() => {
    if (group) {
      setLocalGroup(group);
    }
  }, [group]);

  useEffect(() => {
    if (Object.keys(shareTemplate).length) {
      setDashTitle(shareTemplate?.title);
      setDashDescription(shareTemplate?.description);
      setLocalGroup(shareTemplate?.groups[0]);
      setGThresholds(shareTemplate?.thresholds?.graphThresholds);
      setTThreshold(shareTemplate?.thresholds?.tableThreshold);
    }
  }, [shareTemplate]);

  useEffect(() => {
    if (activeTemplate) {
      setDashTitle(activeTemplate?.title);
      setDashDescription(activeTemplate?.description);
    }
  }, [activeTemplate]);

  useEffect(() => {
    if (dashboard !== 'Load Monitoring') {
      setSelectedStartDate(startDateCal);
    }
  }, [startDateCal]);

  useEffect(() => {
    if (dashboard === 'Load Monitoring') {
      setLoadMonitoringDayRange(
        dayRangeOptions.find((option) => option.value === dayRange),
      );
    }
  }, [dayRange]);

  useEffect(() => {
    if (dashboard === 'Load Monitoring') {
      setSelectedStartDate(
        moment(selectedEndDate).subtract(
          loadMonitoringDayRange.value - 1,
          'days',
        ),
      );
    }
  }, [selectedEndDate, loadMonitoringDayRange]);

  useEffect(() => {
    if (dashboard === 'Load Monitoring' || dashboard === 'VBT') {
      setSelectedEndDate(endDateCal ? moment(endDateCal) : moment());
    } else {
      setSelectedEndDate(endDateCal);
    }
  }, [endDateCal]);

  useEffect(() => {
    if (shareDashLinkError) {
      const newErrors = { ...errors };
      newErrors.errors[2].isShowing = true;
      newErrors.errorsExist = true;
      setErrors(newErrors);
    } else {
      const newErrors = { ...errors };
      newErrors.errors[2].isShowing = false;
      newErrors.errorsExist = false;
      setErrors(newErrors);
    }
  }, [shareDashLinkError]);

  useEffect(() => {
    const dsc = document.getElementById(
      `${dashboard} date-selector-container-1`,
    );
    if (dsc) {
      setDscElement(dsc);
    }
    const dsc2 = document.getElementById(
      `${dashboard} date-selector-container-2`,
    );
    if (dsc2) {
      setDscElement2(dsc2);
    }
  }, []);

  useEffect(() => {
    const prev = prevBucketSizeRef.current;
    if (prev === volumeTrackerBucketSize) return;
    prevBucketSizeRef.current = volumeTrackerBucketSize;

    const [newMin, newMax] = normalizeRange(volumeTrackerMinRange, volumeTrackerMaxRange);

    if (isRangeValid(newMin, newMax)) {
      if (newMin !== volumeTrackerMinRange) setVolumeTrackerMinRange(newMin);
      if (newMax !== volumeTrackerMaxRange) setVolumeTrackerMaxRange(newMax);
      return;
    }

    const fallback = getRangeOptions(newMin)[0];
    setVolumeTrackerMinRange(newMin);
    setVolumeTrackerMaxRange(fallback?.id || null);
  }, [volumeTrackerBucketSize]);

  useEffect(() => {
    if (!isModalShowing) {
      setErrors({
        errorsExist: false,
        errors: [
          {
            error: 'name error',
            msg: 'You must add a title for the shared dashboard',
            isShowing: false,
          },
          {
            error: 'select group error',
            msg: 'You must select a group',
            isShowing: false,
          },
          {
            error: 'API error',
            msg:
              'Unable to create shareable link, please check the form and try again',
            isShowing: false,
          },
          {
            error: 'threshold error',
            msg: 'One or more thresholds are invalid, please check and try again',
            isShowing: false,
          },
          {
            error: 'duplicate threshold error',
            msg: 'You cannot have duplicate performance overview thresholds',
            isShowing: false,
          },
        ],
      });
    }
  }, [isModalShowing]);

  return (
    <>
      {dashboard === 'VBT' ? (
        <ModalContainer isActive={isModalShowing}>
          <RelativePortalContainer>
            <ButtonContainer>
              <div />
              <PortalContainer>
                <RemoveDiv>
                  {activeSlide !== 0 ? (
                    <div
                      className='remove-div-icon'
                      onClick={() => {
                        if (activeSlide === 1) {
                          // Clear threshold errors to stop modal from getting locked
                          const newErrors = { ...errors };
                          newErrors.errors[3].isShowing = false;
                          newErrors.errors[4].isShowing = false;
                          newErrors.errorsExist = false;
                          setErrors(newErrors);
                          setActiveSlide(0);
                        }
                        if (activeSlide === 2) {
                          dispatch(clearShareDashLink());
                          setActiveSlide(1);
                        }
                      }}
                    >
                      <IcomoonReact
                        iconSet={iconSet}
                        size={18}
                        icon='left-arrow'
                        color='#444444'
                      />
                    </div>
                  ) : null}
                  <ModalHeader>
                    <HeaderIconContainer>
                      <IcomoonReact iconSet={iconSet} size={20} icon='share' />
                    </HeaderIconContainer>
                    <ModalHeaderText>Share Dashboard</ModalHeaderText>
                    <ErrorBox>
                      {errors.errors[0].isShowing ? (
                        <MappedError>{errors.errors[0].msg}</MappedError>
                      ) : null}
                      {errors.errors[1].isShowing ? (
                        <MappedError>{errors.errors[1].msg}</MappedError>
                      ) : null}
                      {errors.errors[2].isShowing ? (
                        <MappedError linkError>{errors.errors[2].msg}</MappedError>
                      ) : null}
                      {errors.errors[3].isShowing ? (
                        <MappedError>{errors.errors[3].msg}</MappedError>
                      ) : null}
                      {errors.errors[4]?.isShowing ? (
                        <MappedError>{errors.errors[4].msg}</MappedError>
                      ) : null}
                    </ErrorBox>
                  </ModalHeader>
                  <div className='remove-div-icon' onClick={handleClose}>
                    <IcomoonReact
                      iconSet={iconSet}
                      size={15}
                      icon='remove'
                      color='black'
                    />
                  </div>
                </RemoveDiv>
                <ContentContainer
                  customHeight={activeSlide === 2 ? '200px' : activeSlide === 1 ? '365px' : '500px'}
                >
                  <SlidesContainer customHeight='auto'>
                    <Slides activeSlide={activeSlide}>
                      {/* First Slide */}
                      <Slide>
                        <SharedInput
                          charLimit={50}
                          fontSize='unset'
                          fontWeight={400}
                          height='40px'
                          label='Title'
                          name='dashTitle'
                          onBlur={() => {
                            if (!dashTitle.length) {
                              const newErrors = { ...errors };
                              newErrors.errors[0].isShowing = true;
                              setErrors(newErrors);
                            }
                          }}
                          onChange={(e) => {
                            if (e.target.value.length <= 50) {
                              if (
                                errors.errors[0].isShowing
                                && e.target.value.length
                              ) {
                                const newErrors = { ...errors };
                                newErrors.errors[0].isShowing = false;
                                newErrors.errorsExist = false;
                                setErrors(newErrors);
                              }
                              setDashTitle(e.target.value);
                            }
                          }}
                          placeholder='Title'
                          placeHolderColor='#444444'
                          styledPropsLabel={{
                            marginBottom: 'unset',
                            fontSize: '16px',
                          }}
                          styledPropsWrapper={{
                            display: 'flex',
                            flexDirection: 'column',
                            margin: '10px 0px',
                          }}
                          textColor='#444444'
                          value={dashTitle}
                        />
                        <DashDateWrapper>
                          <DashDateContainer>
                            <DashDescription>
                              Date Range
                            </DashDescription>
                            <DaySelector>
                              <DayOption
                                isActive={localVBTDateRange === 13}
                                onClick={() => setLocalVBTDateRange(13)}
                              >
                                2W
                              </DayOption>
                              <DaySpacer> | </DaySpacer>
                              <DayOption
                                isActive={localVBTDateRange === 27}
                                onClick={() => setLocalVBTDateRange(27)}
                              >
                                4W
                              </DayOption>
                              <DaySpacer> | </DaySpacer>
                              <DayOption
                                isActive={localVBTDateRange === 55}
                                onClick={() => setLocalVBTDateRange(55)}
                              >
                                8W
                              </DayOption>
                            </DaySelector>
                          </DashDateContainer>
                          <DashDateContainer>
                            <DashDescription>
                              End Date
                            </DashDescription>
                            <SharedDatePicker
                              setStartDate={handleSelectEndDate}
                              startDate={selectedEndDate ? new Date(selectedEndDate) : null}
                              styledWrapperProps={{
                                customBorder: '1px solid #CCCCCC',
                                width: 'fit-content',
                              }}
                            />
                          </DashDateContainer>
                        </DashDateWrapper>
                        <Slide2Block2>
                          <BlockText>Group</BlockText>
                          <Select
                            className='item-select'
                            value={localGroup || null}
                            options={groupOptions()}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            onChange={(option) => {
                              const newErrors = { ...errors };
                              newErrors.errors[1].isShowing = false;
                              newErrors.errorsExist = false;
                              setErrors(newErrors);
                              setLocalGroup(option);
                            }}
                            placeholder='Select a group'
                          />
                        </Slide2Block2>
                        <SharedInput
                          charLimit={500}
                          fontSize='unset'
                          fontWeight={400}
                          height='75px'
                          isTextArea
                          label='Description'
                          name='dashDescription'
                          onChange={(e) => {
                            if (e.target.value.length <= 500) {
                              setDashDescription(e.target.value);
                            }
                          }}
                          placeholder='Description (optional)'
                          placeHolderColor='#444444'
                          styledPropsLabel={{
                            marginBottom: 'unset',
                            fontSize: '16px',
                          }}
                          styledPropsWrapper={{
                            display: 'flex',
                            flexDirection: 'column',
                            margin: '10px 0px',
                          }}
                          textColor='#444444'
                          value={dashDescription}
                        />
                      </Slide>
                      {/* Second Slide */}
                      <Slide>
                        <BlockText style={{ fontWeight: 700 }}>
                          Performance Overview Thresholds (optional)
                        </BlockText>
                        <BlockSubtext>
                          Visualize targets by adding up to 3 minimum and maximum thresholds below
                        </BlockSubtext>
                        <ThresholdsContainer direction='column'>
                          <ThresholdContainer>
                            <Min
                              id='min-1'
                              min={0}
                              onChange={(e) => handleThresholdChange(0, 'min', e.target.value)}
                              onKeyDown={preventEAndMinus}
                              placeholder='0.4 m/s'
                              step='0.1'
                              style={{
                                border: errorsMulti[0]?.min ? '2px solid #FF0024' : '2px solid #E0E0E0',
                              }}
                              type='number'
                              value={gThresholds[0]?.min || ''}
                            />
                            <Divider>-</Divider>
                            <Max
                              id='max-1'
                              min={0}
                              onChange={(e) => handleThresholdChange(0, 'max', e.target.value)}
                              onKeyDown={preventEAndMinus}
                              placeholder='0.6 m/s'
                              step='0.1'
                              style={{
                                border: errorsMulti[0]?.max ? '2px solid #FF0024' : '2px solid #E0E0E0',
                              }}
                              type='number'
                              value={gThresholds[0]?.max || ''}
                            />
                          </ThresholdContainer>
                          <ThresholdContainer>
                            <Min
                              id='min-2'
                              min={0}
                              onChange={(e) => handleThresholdChange(1, 'min', e.target.value)}
                              onKeyDown={preventEAndMinus}
                              placeholder='0.4 m/s'
                              step='0.1'
                              style={{
                                border: errorsMulti[1]?.min ? '2px solid #FF0024' : '2px solid #E0E0E0',
                              }}
                              type='number'
                              value={gThresholds[1]?.min || ''}
                            />
                            <Divider>-</Divider>
                            <Max
                              id='max-2'
                              min={0}
                              onChange={(e) => handleThresholdChange(1, 'max', e.target.value)}
                              onKeyDown={preventEAndMinus}
                              placeholder='0.6 m/s'
                              step='0.1'
                              style={{
                                border: errorsMulti[1]?.max ? '2px solid #FF0024' : '2px solid #E0E0E0',
                              }}
                              type='number'
                              value={gThresholds[1]?.max || ''}
                            />
                          </ThresholdContainer>
                          <ThresholdContainer>
                            <Min
                              id='min-3'
                              min={0}
                              onChange={(e) => handleThresholdChange(2, 'min', e.target.value)}
                              onKeyDown={preventEAndMinus}
                              placeholder='0.4 m/s'
                              step='0.1'
                              style={{
                                border: errorsMulti[2]?.min ? '2px solid #FF0024' : '2px solid #E0E0E0',
                              }}
                              type='number'
                              value={gThresholds[2]?.min || ''}
                            />
                            <Divider>-</Divider>
                            <Max
                              id='max-3'
                              min={0}
                              onChange={(e) => handleThresholdChange(2, 'max', e.target.value)}
                              onKeyDown={preventEAndMinus}
                              placeholder='0.6 m/s'
                              step='0.1'
                              style={{
                                border: errorsMulti[2]?.max ? '2px solid #FF0024' : '2px solid #E0E0E0',
                              }}
                              type='number'
                              value={gThresholds[2]?.max || ''}
                            />
                          </ThresholdContainer>
                        </ThresholdsContainer>
                        <BlockText style={{ fontWeight: 700 }}>
                          Group Analysis Threshold (optional)
                        </BlockText>
                        <BlockSubtext>
                          Visualize targets by adding minimum and maximum thresholds below
                        </BlockSubtext>
                        <ThresholdsContainer direction='row'>
                          <Min
                            id='min-4'
                            min={0}
                            onChange={(e) => handleTableThresholdChange('min', e.target.value)}
                            onKeyDown={preventEAndMinus}
                            placeholder='0.4 m/s'
                            step='0.1'
                            style={{
                              border: errorsThreshold.min ? '2px solid #FF0024' : '2px solid #E0E0E0',
                            }}
                            type='number'
                            value={tThreshold.min}
                          />
                          <Divider>-</Divider>
                          <Max
                            id='max-4'
                            min={0}
                            onChange={(e) => handleTableThresholdChange('max', e.target.value)}
                            onKeyDown={preventEAndMinus}
                            placeholder='0.6 m/s'
                            step='0.1'
                            style={{
                              border: errorsThreshold.max ? '2px solid #FF0024' : '2px solid #E0E0E0',
                            }}
                            type='number'
                            value={tThreshold.max}
                          />
                        </ThresholdsContainer>
                      </Slide>
                      {/* Third Slide */}
                      <Slide>
                        <SlideCenterDiv>
                          {shareDashLink && !shareDashLinkError && (
                            <>
                              <DownloadLinkDescText>
                                This link is specific to this dashboard and will
                                expire in 30 days
                              </DownloadLinkDescText>
                              <DashLinkContainer>
                                <TextAndCopy>
                                  <DashLink>Download Link</DashLink>
                                  <animated.div style={copyAnimation}>
                                    <Text
                                      fontSize={18}
                                      style={{ margin: '0px 0px 0px 10px' }}
                                    >
                                      Copied Dashboard URL!
                                    </Text>
                                  </animated.div>
                                </TextAndCopy>
                                <DashLinkBox
                                  hasLink={!!shareDashLink}
                                  onClick={
                                    shareDashLink
                                      ? copyToClipboard
                                      : () => undefined
                                  }
                                >
                                  {shareDashLink}
                                </DashLinkBox>
                              </DashLinkContainer>
                            </>
                          )}
                        </SlideCenterDiv>
                      </Slide>
                    </Slides>
                  </SlidesContainer>
                </ContentContainer>
              </PortalContainer>
              <SlideIndicators>
                <SlideIndicator isActive={activeSlide === 0} />
                <SlideIndicator isActive={activeSlide === 1} />
                <SlideIndicator isActive={activeSlide === 2} />
              </SlideIndicators>
              <Button
                bgColor='#424242'
                bottom
                disabled={errors.errorsExist === true}
                fontSize='14px'
                fullWidth
                isLoading={shareDashLinkLoading}
                large
                name={activeSlide === 2 ? 'Close' : 'Next'}
                noBorder
                onClick={vbtHandleSubmit}
                square
                styledWrapperProps={{
                  borderBottomLeftRadius: '12px',
                  borderBottomRightRadius: '12px',
                }}
                txtColor='#FFFFFF'
                upperCase
              />
            </ButtonContainer>
          </RelativePortalContainer>
        </ModalContainer>
      ) : (
        <ModalContainer
          onClick={(e) => {
            if (
              e.target !== 'floating-datepicker-selector'
              && (pickerOpen || pickerOpen2)
            ) {
              setPickerOpen(false);
              setPickerOpen2(false);
            }
          }}
          isActive={isModalShowing}
        >
          <RelativePortalContainer>
            <div id={`${dashboard} date-selector-container-1`} />
            <div id={`${dashboard} date-selector-container-2`} />
            <ButtonContainer>
              <div />
              <PortalContainer>
                <RemoveDiv>
                  {activeSlide !== 0 ? (
                    <div
                      className='remove-div-icon'
                      onClick={() => {
                        if (activeSlide === 1) {
                          dispatch(clearShareDashLink());
                          setActiveSlide(0);
                        }
                      }}
                    >
                      <IcomoonReact
                        iconSet={iconSet}
                        size={18}
                        icon='left-arrow'
                        color='#444444'
                      />
                    </div>
                  ) : null}
                  <ModalHeader>
                    <HeaderIconContainer>
                      <IcomoonReact iconSet={iconSet} size={20} icon='share' />
                    </HeaderIconContainer>
                    <ModalHeaderText>Share Dashboard</ModalHeaderText>
                    <ErrorBox>
                      {errors.errors[0].isShowing ? (
                        <MappedError>{errors.errors[0].msg}</MappedError>
                      ) : null}
                      {errors.errors[1].isShowing ? (
                        <MappedError>{errors.errors[1].msg}</MappedError>
                      ) : null}
                      {errors.errors[2].isShowing ? (
                        <MappedError linkError>{errors.errors[2].msg}</MappedError>
                      ) : null}
                    </ErrorBox>
                  </ModalHeader>
                  <div className='remove-div-icon' onClick={handleClose}>
                    <IcomoonReact
                      iconSet={iconSet}
                      size={15}
                      icon='remove'
                      color='black'
                    />
                  </div>
                </RemoveDiv>
                <ContentContainer
                  customHeight={activeSlide === 1 ? '200px' : '500px'}
                >
                  <SlidesContainer customHeight='auto'>
                    <Slides activeSlide={activeSlide}>
                      {/* First slide */}
                      <Slide>
                        <SharedInput
                          charLimit={50}
                          fontSize='unset'
                          fontWeight={400}
                          height='40px'
                          label='Title'
                          name='dashTitle'
                          onBlur={() => {
                            if (!dashTitle.length) {
                              const newErrors = { ...errors };
                              newErrors.errors[0].isShowing = true;
                              setErrors(newErrors);
                            }
                          }}
                          onChange={(e) => {
                            if (e.target.value.length <= 50) {
                              if (
                                errors.errors[0].isShowing
                                && e.target.value.length
                              ) {
                                const newErrors = { ...errors };
                                newErrors.errors[0].isShowing = false;
                                newErrors.errorsExist = false;
                                setErrors(newErrors);
                              }
                              setDashTitle(e.target.value);
                            }
                          }}
                          placeholder='Title'
                          placeHolderColor='#444444'
                          styledPropsLabel={{
                            marginBottom: 'unset',
                            fontSize: '16px',
                          }}
                          styledPropsWrapper={{
                            display: 'flex',
                            flexDirection: 'column',
                            margin: '10px 0px',
                          }}
                          textColor='#444444'
                          value={dashTitle}
                        />
                        <DashDateWrapper>
                          {dashboard === 'Load Monitoring' && (
                            <DashDateContainer>
                              <BlockText>Dashboard Day Range</BlockText>
                              <Select
                                className='day-range-select'
                                value={loadMonitoringDayRange}
                                // defaultValue={dayRangeOptions[0]}
                                options={dayRangeOptions}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }}
                                getOptionLabel={(option) => option.label}
                                getOptionValue={(option) => option.value}
                                onChange={(option) => {
                                  setLoadMonitoringDayRange(option);
                                }}
                              />
                            </DashDateContainer>
                          )}
                          {dashboard !== 'Load Monitoring' && (
                            <DashDateContainer>
                              <DashDescription>Start Date</DashDescription>
                              <DatePickerDiv
                                onClick={
                                  dashboard !== 'Load Monitoring'
                                    ? () => setPickerOpen(!pickerOpen)
                                    : () => undefined
                                }
                              >
                                <DatePickerText
                                  disabled={dashboard === 'Load Monitoring'}
                                >
                                  {selectedStartDate
                                    ? selectedStartDate.format('YYYY-MM-DD')
                                    : 'Choose Date'}
                                </DatePickerText>
                                {dscElement
                                  ? createPortal(
                                    <ShareDatePicker
                                      id='floating-datepicker-selector'
                                      isDayPickerOpen={pickerOpen}
                                      setIsDayPickerOpen={setPickerOpen}
                                      activeDate={selectedStartDate}
                                      selectDate={handleSelectStartDate}
                                      disabledCondition={disabledStartDate}
                                      left={100}
                                    />,
                                    dscElement,
                                  )
                                  : null}
                              </DatePickerDiv>
                            </DashDateContainer>
                          )}
                          <DashDateContainer>
                            <DashDescription>
                              {dashboard === 'Load Monitoring'
                                ? 'Date'
                                : 'End Date'}
                            </DashDescription>
                            <DatePickerDiv2
                              onClick={() => setPickerOpen2(!pickerOpen2)}
                            >
                              <DatePickerText>
                                {selectedEndDate
                                  ? selectedEndDate.format('YYYY-MM-DD')
                                  : 'Choose Date'}
                              </DatePickerText>
                              {dscElement2
                                ? createPortal(
                                  <ShareDatePicker
                                    id='floating-datepicker-selector2'
                                    isDayPickerOpen={pickerOpen2}
                                    setIsDayPickerOpen={setPickerOpen2}
                                    activeDate={selectedEndDate}
                                    selectDate={handleSelectEndDate}
                                    disabledCondition={
                                        dashboard === 'Load Monitoring'
                                          ? () => false
                                          : disabledEndDate
                                      }
                                    right={100}
                                  />,
                                  dscElement2,
                                )
                                : null}
                            </DatePickerDiv2>
                          </DashDateContainer>
                        </DashDateWrapper>
                        {dashboard === 'Volume Tracker' && (
                          <VolumeTrackerWrapper>
                            <FlexWrapper>
                              <BucketWrapper>
                                <BlockText>Percentage Increments</BlockText>
                                <Select
                                  options={[
                                    { label: '5%', value: 5 },
                                    { label: '10%', value: 10 },
                                  ]}
                                  value={{
                                    label: `${volumeTrackerBucketSize}%`,
                                    value: volumeTrackerBucketSize,
                                  }}
                                  onChange={(option) => setVolumeTrackerBucketSize(option.value)}
                                  menuPortalTarget={document.body}
                                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                                />
                              </BucketWrapper>
                              <RangeWrapper>
                                <BlockText>Volume Range</BlockText>
                                <div className='volume-tracker-range'>
                                  <Select
                                    className='volume-tracker-select'
                                    options={rangeOptions}
                                    value={rangeOptions.find(
                                      (opt) => opt.id === volumeTrackerMinRange,
                                    )}
                                    getOptionValue={(opt) => opt.id}
                                    getOptionLabel={(opt) => opt.label}
                                    onChange={handleRangeMin}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                  <BlockText>to</BlockText>
                                  <Select
                                    className='volume-tracker-select'
                                    options={getRangeOptions(volumeTrackerMinRange)}
                                    value={getRangeOptions(volumeTrackerMinRange).find(
                                      (opt) => opt.id === volumeTrackerMaxRange,
                                    )}
                                    getOptionValue={(opt) => opt.id}
                                    getOptionLabel={(opt) => opt.label}
                                    onChange={(option) => setVolumeTrackerMaxRange(option.id)}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                      }),
                                    }}
                                  />
                                </div>
                              </RangeWrapper>
                            </FlexWrapper>
                            <NoteText>
                              End range will be used to generate
                              buckets for Assigned/Completed view (max 5 buckets).
                            </NoteText>
                          </VolumeTrackerWrapper>
                        )}
                        <Slide2Block2>
                          <BlockText>Group</BlockText>
                          <Select
                            className='item-select'
                            value={localGroup || null}
                            options={groupOptions()}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                            }}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            onChange={(option) => {
                              const newErrors = { ...errors };
                              newErrors.errors[1].isShowing = false;
                              newErrors.errorsExist = false;
                              setErrors(newErrors);
                              setLocalGroup(option);
                            }}
                            placeholder='Select a group'
                          />
                        </Slide2Block2>
                        <SharedInput
                          charLimit={500}
                          fontSize='unset'
                          fontWeight={400}
                          height='75px'
                          isTextArea
                          label='Description'
                          name='dashDescription'
                          onChange={(e) => {
                            if (e.target.value.length <= 500) {
                              setDashDescription(e.target.value);
                            }
                          }}
                          placeholder='Description (optional)'
                          placeHolderColor='#444444'
                          styledPropsLabel={{
                            marginBottom: 'unset',
                            fontSize: '16px',
                          }}
                          styledPropsWrapper={{
                            display: 'flex',
                            flexDirection: 'column',
                            margin: '10px 0px',
                          }}
                          textColor='#444444'
                          value={dashDescription}
                        />
                      </Slide>
                      {/* Second slide */}
                      <Slide>
                        <SlideCenterDiv>
                          {shareDashLink && !shareDashLinkError && (
                            <>
                              <DownloadLinkDescText>
                                This link is specific to this dashboard and will
                                expire in 30 days
                              </DownloadLinkDescText>
                              <DashLinkContainer>
                                <TextAndCopy>
                                  <DashLink>Download Link</DashLink>
                                  <animated.div style={copyAnimation}>
                                    <Text
                                      fontSize={18}
                                      style={{ margin: '0px 0px 0px 10px' }}
                                    >
                                      Copied Dashboard URL!
                                    </Text>
                                  </animated.div>
                                </TextAndCopy>
                                <DashLinkBox
                                  hasLink={!!shareDashLink}
                                  onClick={
                                    shareDashLink
                                      ? copyToClipboard
                                      : () => undefined
                                  }
                                >
                                  {shareDashLink}
                                </DashLinkBox>
                              </DashLinkContainer>
                            </>
                          )}
                        </SlideCenterDiv>
                      </Slide>
                    </Slides>
                  </SlidesContainer>
                </ContentContainer>
              </PortalContainer>
              <SlideIndicators>
                <SlideIndicator isActive={activeSlide === 0} />
                <SlideIndicator isActive={activeSlide === 1} />
              </SlideIndicators>
              <Button
                bgColor='#424242'
                bottom
                disabled={errors.errorsExist === true}
                fontSize='14px'
                fullWidth
                isLoading={shareDashLinkLoading}
                large
                name={activeSlide === 1 ? 'Close' : 'Next'}
                noBorder
                onClick={handleSubmit}
                square
                styledWrapperProps={{
                  borderBottomLeftRadius: '12px',
                  borderBottomRightRadius: '12px',
                }}
                txtColor='#FFFFFF'
                upperCase
              />
            </ButtonContainer>
          </RelativePortalContainer>
        </ModalContainer>
      )}
      <SharedTemplateModalContainer
        isModalShowing={isModalShowing}
        onClose={handleClose}
      />
    </>
  );
};

ShareDashboardModal.defaultProps = {
  dashboard: 'Wearables',
  legacyName: 'Wearables',
};

ShareDashboardModal.propTypes = {
  dashboard: PropTypes.string,
  legacyName: PropTypes.string,
};

export default ShareDashboardModal;
